<template>
  <div>
    <div class="filter-container">
      <el-row :gutter="10">
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.report_number" :placeholder="$t('请输入检测报告编号')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.owner_name" :placeholder="$t('请输入车主姓名（单位）')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.owner_contact" :placeholder="$t('请输入联系电话')" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <el-select v-model="listQuery.inspection_result" clearable placeholder="请选择" @keyup.enter.native="handleFilter">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
          {{ $t('admin.search_btn') }}
        </el-button>
      </el-row>
    </div>

    <el-table
      ref="onTable"
      v-loading="loading"
      :data="list"
      border
      style="width: 100%"
      element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="report_number" :label="$t('on_road.report_number')" />
      <el-table-column prop="owner_name" :label="$t('on_road.owner_name')" />
      <el-table-column prop="owner_contact" :label="$t('on_road.owner_contact')" />
      <el-table-column prop="license_plate_number" :label="$t('on_road.license_plate_number')" />
      <el-table-column prop="vehicle_model" :label="$t('on_road.vehicle_model')" />
      <el-table-column :label="$t('on_road.inspection_result')">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.inspection_result" type="info">未检测</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '合格'" type="success">{{ scope.row.inspection_result }}</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '不合格'" type="danger">{{ scope.row.inspection_result }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="admin.nickname" :label="$t('on_road.inspector')" />
      <el-table-column prop="inspection_date" label="检测日期" />
      <!--   当前状态    -->
      <el-table-column label="当前审批状态">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.stage" type="success" effect="dark">待检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 1" type="success">已检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 2" type="warning" effect="dark">待审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 3" type="warning">已审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 4" effect="dark">待批准</el-tag>
          <el-tag v-else-if="scope.row.stage === 5">已批准</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" :label="$t('on_road.created_at')" />
      <el-table-column align="left" :label="$t('admin.table_actions')" width="320">
        <template slot-scope="scope">
          <!--   详情   -->
          <el-button
            v-waves
            size="mini"
            type="info"
            :disabled="!checkPermission(['larke-admin.cert.detail'])"
            @click="handleDetail(scope.row)"
          >
            详情
          </el-button>
          <el-button
            v-waves
            size="mini"
            type="primary"
            :disabled="!checkPermission(['larke-admin.cert.update'])"
            @click="handleEditOnRoad(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            v-waves
            size="mini"
            type="danger"
            :disabled="!checkPermission(['larke-admin.cert.delete'])"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
          <!--  打印  -->
          <el-button
            v-waves
            size="mini"
            type="success"
            :disabled="!checkPermission(['larke-admin.cert.print'])"
            @click="handlePrint(scope.row)"
          >
            打印
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="handleTable"
    />
    <!--  编辑道路车辆检验（测）报告   -->
    <el-dialog
      title="编辑道路车辆检验（测）报告"
      :visible.sync="editOnRoad.dialogVisible"
      width="1300px"
    >
      <edit-on-road :item="editOnRoad" @success:edit="handleEditOnRoadSuccess" />
    </el-dialog>
    <!--  预览道路车辆检验（测）报告   -->
    <el-dialog
      title="预览道路车辆检验（测）报告"
      :visible.sync="previewOnRoad.dialogVisible"
      width="1000px"
    >
      <preview-on-road :item="previewOnRoad" />
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import checkPermission from '@/utils/permission' // 权限判断函数
import permission from '@/directive/permission'
import { listOnRoad } from '@/api/cert'
import Pagination from '@/components/Pagination'
import PreviewOnRoad from '@/views/cert/Components/PreviewOnRoad.vue'
import { deleteOnRoad } from '@/api/verification'
import EditOnRoad from '@/views/cert/Components/EditOnRoad.vue'
export default {
  name: 'OnRoad',
  components: { EditOnRoad, PreviewOnRoad, Pagination },
  directives: { waves, permission },
  data() {
    return {
      loading: false,
      previewOnRoad: {
        dialogVisible: false,
        id: 0,
        isPrint: false
      },
      editOnRoad: {
        dialogVisible: false,
        id: 0
      },
      total: 0,
      list: [],
      options: [
        { label: '合格', value: '合格' },
        { label: '不合格', value: '不合格' }
      ],
      listQuery: {
        page: 1,
        limit: 20,
        report_number: '',
        owner_name: '',
        owner_contact: '',
        inspection_result: ''
      }
    }
  },
  created() {
    this.handleTable()
  },
  methods: {
    handleTable() {
      this.loading = true
      listOnRoad(this.listQuery).then(response => {
        this.list = response.data.data
        this.total = response.data.total
      })
      this.loading = false
    },
    checkPermission,
    handleFilter() {
      this.handleTable()
    },
    handleDetail(row) {
      this.previewOnRoad.dialogVisible = true
      this.previewOnRoad.id = row.id
      this.previewOnRoad.isPrint = false
    },
    handlePrint(row) {
      this.previewOnRoad.dialogVisible = true
      this.previewOnRoad.id = row.id
      this.previewOnRoad.isPrint = true
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOnRoad(row.id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.handleTable()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleEditOnRoad(row) {
      this.editOnRoad.dialogVisible = true
      this.editOnRoad.id = row.id
    },
    handleEditOnRoadSuccess() {
      this.editOnRoad.dialogVisible = false
      this.handleTable()
    }
  }
}
</script>

<style scoped>

</style>
